import {
  FaBlog,
  FaChartPie,
  FaCodeBranch,
  FaListAlt,
  FaPrint,
  FaRegChartBar,
  FaSms,
  FaUsers,
  FaUtensils,
  FaWarehouse
} from "react-icons/fa"
import { AiFillPicture } from "react-icons/ai"
import { FaGears } from "react-icons/fa6"
import { HiOutlineSpeakerphone } from "react-icons/hi"
import { GrUserWorker } from "react-icons/gr"
import { IoColorPaletteOutline } from "react-icons/io5"

const navItems = [
  {
    title: "داشبورد",
    collapse: false,
    path: "/dashboard",
    icon: <FaRegChartBar />,
    items: []
  },
  {
    title: "سفارشات",
    collapse: true,
    path: "",
    icon: <FaListAlt />,
    items: [
      {
        path: "/orders-not-confirmed",
        title: "سفارشات_در_انتظار_تایید",
        requiredAccess: "viewLatestOrders",
        badge: true,
        badgeField: "notConfirmed"
      },
      {
        path: "/orders-pending",
        title: "سفارشات_پرداخت_نشده",
        requiredAccess: "viewLatestOrders",
        badge: true,
        badgeField: "pending"
      },
      {
        path: "/orders-paid",
        title: "سفارشات_پرداخت_شده",
        requiredAccess: "viewLatestOrders",
        badge: true,
        badgeField: "paid"
      },
      {
        path: "/marketplace-orders",
        title: "سفارشات_عمومی_فراسود",
        requiredAccess: "viewLatestOrders"
      },
      {
        path: "/orders-delivered",
        title: "سفارشات_تکمیل_شده",
        requiredAccess: "viewOrderHistory",
        badge: true,
        badgeField: "delivered"
      },
      {
        path: "/orders-problematic",
        title: "سفارشات_تایید_نشده",
        requiredAccess: "viewLatestOrders"
      },
      {
        path: "/orders-canceled",
        title: "سفارشات_لغو_شده",
        requiredAccess: "viewCanceledOrders",
        badge: true,
        badgeField: "canceled"
      }
    ]
  },
  {
    title: "مدیریت_کالا",
    collapse: true,
    path: "",
    icon: <FaUtensils />,
    items: [
      {
        path: "/food-list",
        title: "فهرست_کالا",
        value: "foodList",
        requiredAccess: "viewFoodList"
      },
      {
        path: "/add-on-list",
        title: "فهرست_افزودنی_ها",
        requiredAccess: "viewAddOnList"
      },
      {
        path: "/categories",
        title: "دسته_بندی_ها",
        requiredAccess: "viewCategories"
      },
      // {
      //   path: "/recommended-foods",
      //   title: "کالا های پیشنهاد شده",
      //   requiredAccess: "viewRecommendedFoods"
      // },
      {
        path: "/foods-branch",
        title: "افزودن_کالا_به_شعبه",
        requiredAccess: "addFoodsToBranch"
      },
      {
        path: "/inventory",
        title: "مدیریت_موجودی",
        requiredAccess: "inventory"
      },
      {
        path: "/food-price-list",
        title: "مدیریت_قیمت_کالا_ها",
        requiredAccess: "viewFoodPriceList"
      },
      {
        path: "/food-features",
        title: "خصوصیات_کالا",
        requiredAccess: "viewFoodFeatures"
      },
      {
        path: "/taxes-and-charges",
        title: "مالیات_و_خدمات",
        requiredAccess: "viewTaxList"
      },
      {
        path: "/food-option-list",
        title: "لیست_تنوع_ها",
        requiredAccess: "viewFoodOptionList"
      },
      {
        path: "/food-descriptions-list",
        title: "لیست_توضیحات_تکمیلی",
        requiredAccess: "viewFoodLongDescriptionsList"
      }
    ]
  },
  {
    title: "باشگاه_مشتریان",
    collapse: true,
    path: "",
    icon: <FaUsers />,
    items: [
      {
        path: "/customers",
        title: "لیست_مشتریان",
        requiredAccess: "viewCustomersList",
      },
      {
        path: "/coupons",
        title: "کوپن_ها",
        requiredAccess: "viewCouponsList"
      },
      {
        path: "/subscription-levels",
        title: "مدیریت_سطح_عضویت",
        requiredAccess: "viewSubscriptionLevels"
      },
      {
        path: "/achievements",
        title: "مدیریت_چالش_ها",
        requiredAccess: "viewAchievements"
      }
    ]
  },
  {
    title: "گزارشات",
    collapse: true,
    path: "",
    icon: <FaChartPie />,
    items: [
      {
        path: "/reports",
        title: "گزارش_فروش",
        requiredAccess: "viewReports"
      },
      {
        path: "/wallet-transactions",
        title: "گزارش_اعتبار_مشتریان",
        requiredAccess: "viewWalletTransactions"
      },
      {
        path: "/farasod-wallet-transactions",
        title: "گزارش_اعتبار_فراسود",
        requiredAccess: "viewWalletTransactions"
      },
      {
        path: "/shift-history",
        title: "شیفت_ها",
        requiredAccess: "viewShifts"
      }
    ]
  },
  {
    title: "وبلاگ_ها",
    collapse: false,
    path: "/blogs",
    icon: <FaBlog />,
    items: []
  },
  {
    title: "پیامک_ها",
    collapse: true,
    path: "",
    icon: <FaSms />,
    items: [
      {
        path: "/sms-panel",
        title: "پنل پیامکی",
        requiredAccess: "viewSmsPanel"
      },
      {
        path: "/sms-history",
        title: "گزارش_پیامک_ها",
        requiredAccess: "viewSmsHistory"
      }
    ]
  },
  {
    title: "تبلیغات",
    collapse: true,
    path: "",
    icon: <HiOutlineSpeakerphone />,
    items: [
      {
        path: "/campaigns",
        title: "کمپین_تبلیغاتی",
        requiredAccess: "viewCampaigns"
      }
    ]
  },
  {
    title: "مدیریت_شعبه_ها",
    collapse: false,
    path: "/branches",
    icon: <FaCodeBranch />,
    requiredAccess: "viewBranches",
    items: []
  },
  {
    title: "پرسنل",
    collapse: true,
    path: "",
    icon: <GrUserWorker />,
    items: [
      {
        path: "/account-management",
        title: "مدیریت_پرسنل",
        requiredAccess: "viewStaff"
      },
      {
        path: "/role-management",
        title: "مدیریت_دسترسی_ها",
        requiredAccess: "viewAccessList"
      }
    ]
  },
  {
    path: "/customer-print-template",
    title: "قالب_پرینت_رسید_مشتری",
    collapse: false,
    icon: <FaPrint />,
    requiredAccess: "viewCustomerPrintTemplate",
    items: []
  },
  {
    title: "تنظیمات",
    collapse: true,
    path: "",
    icon: <FaGears />,
    items: [
      {
        path: "/page-decoration",
        title: "صفحه_ی_فروشگاه",
        requiredAccess: "viewPageDecoration"
      },
      {
        path: "/settings",
        title: "سیستم",
        requiredAccess: "viewSystemSettings"
      },
      {
        path: "/payment-gateways",
        title: "درگاه_پرداخت",
        requiredAccess: "viewSystemSettings"
      },
      {
        path: "/marketplace-settings",
        title: "گزارش_فروش_عمومی",
        requiredAccess: "viewSystemSettings"
      },
      {
        path: "/locations",
        title: "روش_های_ارسال",
      }
    ]
  },
  {
    path: "/theme-management",
    title: "تم_سایت",
    collapse: false,
    icon: <IoColorPaletteOutline />,
    requiredAccess: "viewThemeMangement",
    items: []
  },
  {
    title: "مدیا",
    collapse: true,
    icon: <AiFillPicture />,
    items: [
      {
        path: "/media",
        title: "عکس_های_آپلود_شده",
        requiredAccess: "viewMedia"
      }
    ]
  },
  {
    title: "انبارداری",
    collapse: true,
    icon: <FaWarehouse />,
    serviceTypeName: "shop",
    items: [
      {
        path: "/repository-management",
        title: "خروج_از_انبار",
        requiredAccess: "repositoryManagement"
      },
      {
        path: "/repository-report",
        title: "گزارش_انبارداری",
        requiredAccess: "repositoryManagement"
      }
    ]
  }
]

export default navItems
